export default "__VITE_ASSET__kGhxKljB__"